import { render, staticRenderFns } from "./MasterCustomer.vue?vue&type=template&id=64a24dec&"
import script from "./MasterCustomer.vue?vue&type=script&lang=js&"
export * from "./MasterCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports